export const HOUSEHOLD_APPLICATION_ACTION_HOMEOWNER_INFO_UPDATED = 'homeOwnerInfoUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_PINWHEEL_LINKED = 'pinwheelLinked';
export const HOUSEHOLD_APPLICATION_ACTION_PAYSTUB_UPDATED = 'paystubUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_BANK_STATEMENT_UPDATED = 'bankStatementUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_OFFER_LETTER_UPDATED = 'offerLetterUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_OTHER_INCOME_DOCUMENT_UPDATED =
  'otherIncomeDocumentUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_MOVE_IN_DATE_UPDATED = 'moveInDateUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_LEASE_TERM_UPDATED = 'leaseTermUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED = 'vorContactUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_EMPLOYMENT_INFORMATION_UPDATED =
  'employmentInformationUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED = 'voeContactUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED = 'previousEmploymentUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_GOVERNMENT_PHOTO_ID_UPDATED = 'photoIdUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYER_INFO_UPDATED =
  'previousEmployerInfoUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_DEPENDENTS_UPDATED = 'dependentsUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_PETS_UPDATED = 'petsUpdated';
export const HOUSEHOLD_APPLICATION_ACTION_VEHICLES_UPDATED = 'vehiclesUpdated';

export const HOUSEHOLD_APPLICATION_ACTIONS_ALL = [
  HOUSEHOLD_APPLICATION_ACTION_HOMEOWNER_INFO_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_PINWHEEL_LINKED,
  HOUSEHOLD_APPLICATION_ACTION_PAYSTUB_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_BANK_STATEMENT_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_OFFER_LETTER_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_OTHER_INCOME_DOCUMENT_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_MOVE_IN_DATE_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_LEASE_TERM_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_EMPLOYMENT_INFORMATION_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_GOVERNMENT_PHOTO_ID_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYER_INFO_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_DEPENDENTS_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_PETS_UPDATED,
  HOUSEHOLD_APPLICATION_ACTION_VEHICLES_UPDATED,
];

export const HOUSEHOLD_APPLICATION_ACTION_TO_TEXT_MAPPING = {
  [HOUSEHOLD_APPLICATION_ACTION_HOMEOWNER_INFO_UPDATED]: 'Homeowner Information Updated',
  [HOUSEHOLD_APPLICATION_ACTION_PINWHEEL_LINKED]: 'Pinwheel Linked',
  [HOUSEHOLD_APPLICATION_ACTION_PAYSTUB_UPDATED]: 'Paystub Updated',
  [HOUSEHOLD_APPLICATION_ACTION_BANK_STATEMENT_UPDATED]: 'Bank Statement Updated',
  [HOUSEHOLD_APPLICATION_ACTION_OFFER_LETTER_UPDATED]: 'Offer Letter Updated',
  [HOUSEHOLD_APPLICATION_ACTION_OTHER_INCOME_DOCUMENT_UPDATED]: 'Other Income Document Updated',
  [HOUSEHOLD_APPLICATION_ACTION_MOVE_IN_DATE_UPDATED]: 'Move-in Date Updated',
  [HOUSEHOLD_APPLICATION_ACTION_LEASE_TERM_UPDATED]: 'Lease Term Updated',
  [HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED]: 'VOR Contact Updated',
  [HOUSEHOLD_APPLICATION_ACTION_EMPLOYMENT_INFORMATION_UPDATED]: 'Employment Information Updated',
  [HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED]: 'VOE Contact Updated',
  [HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED]: 'Previous Employment Updated',
  [HOUSEHOLD_APPLICATION_ACTION_GOVERNMENT_PHOTO_ID_UPDATED]: 'Government Photo ID Updated',
  [HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYER_INFO_UPDATED]: 'Previous Employer Info Updated',
  [HOUSEHOLD_APPLICATION_ACTION_DEPENDENTS_UPDATED]: 'Dependents Updated',
  [HOUSEHOLD_APPLICATION_ACTION_PETS_UPDATED]: 'Pets Updated',
  [HOUSEHOLD_APPLICATION_ACTION_VEHICLES_UPDATED]: 'Vehicles Updated',
};

export const renterAppFormFieldToHouseholdAppActionMapping = {
  isHomeowner: HOUSEHOLD_APPLICATION_ACTION_HOMEOWNER_INFO_UPDATED,
  proofOfHomeOwnershipUrl: HOUSEHOLD_APPLICATION_ACTION_HOMEOWNER_INFO_UPDATED,
  paystubPhotos: HOUSEHOLD_APPLICATION_ACTION_PAYSTUB_UPDATED,
  bankStatementFileUrls: HOUSEHOLD_APPLICATION_ACTION_BANK_STATEMENT_UPDATED,
  offerLetterFileUrl: HOUSEHOLD_APPLICATION_ACTION_OFFER_LETTER_UPDATED,
  additionalProofOfIncomePhotos: HOUSEHOLD_APPLICATION_ACTION_OTHER_INCOME_DOCUMENT_UPDATED,
  moveInDate: HOUSEHOLD_APPLICATION_ACTION_MOVE_IN_DATE_UPDATED,
  leaseTerm: HOUSEHOLD_APPLICATION_ACTION_LEASE_TERM_UPDATED,
  pets: HOUSEHOLD_APPLICATION_ACTION_PETS_UPDATED,
  vehicles: HOUSEHOLD_APPLICATION_ACTION_VEHICLES_UPDATED,

  children: HOUSEHOLD_APPLICATION_ACTION_DEPENDENTS_UPDATED,
  childrenCount: HOUSEHOLD_APPLICATION_ACTION_DEPENDENTS_UPDATED,

  currentLandlordName: HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED,
  currentLandlordEmail: HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED,
  currentLandlordPhone: HOUSEHOLD_APPLICATION_ACTION_VOR_CONTACT_UPDATED,

  currentJobSupervisorName: HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED,
  currentJobSupervisorPhoneNumber: HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED,
  currentJobEmployerEmail: HOUSEHOLD_APPLICATION_ACTION_VOE_CONTACT_UPDATED,

  previousJobCompany: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobPosition: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobMonthlyIncome: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobSupervisorName: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobSupervisorPhoneNumber: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobEmployerEmail: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobMailingAddress: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobStartDate: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,
  previousJobEndDate: HOUSEHOLD_APPLICATION_ACTION_PREVIOUS_EMPLOYMENT_UPDATED,

  governmentIdPhoto: HOUSEHOLD_APPLICATION_ACTION_GOVERNMENT_PHOTO_ID_UPDATED,
};
